import { Action } from 'react-fetching-library';

export function logout({ userId }: { userId: number }): Action {
  return {
    method: 'POST',
    endpoint: `auth/logout/${userId}`,
  };
}
